import { useSelector } from 'react-redux';
import { useFlagsmith } from 'flagsmith/react';

import { useProcessFlags } from 'app/lib/feature-flags/useProcessFlags';
import useComponentWillMount from 'app/lib/hooks/useComponentWillMount';
import { getBrandName } from 'app/packages/brand';
import { isSSR } from 'app/packages/components';
import { useComponentWillReceiveProps } from 'app/packages/lib/hooks';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import { getDefaultRegion } from '../site-configs/selectors';

type useFeatureFlagsInitProps = {
  query: Record<string, string | undefined>;
  config: {
    identity: string;
  };
};

export const useFeatureFlagsInit = ({ query, config }: useFeatureFlagsInitProps): void => {
  const processFlags = useProcessFlags();

  const flagsmith = useFlagsmith();
  const region = useSelector(getDefaultRegion);
  const isLoggedIn = useSelector(selectIsLoggedIn);

  useComponentWillReceiveProps(() => {
    flagsmith.setTraits({
      region: region ?? null,
      brand: getBrandName(),
    });

    flagsmith.identify(config.identity);
  }, [isLoggedIn]);

  useComponentWillMount(() => {
    if (isSSR) {
      const ff = query?.ff || '';

      processFlags(ff);
    }
    else {
      const params = new URLSearchParams(window.location.search);
      const ff = params.get('ff') || '';

      processFlags(ff);
    }
  });
};
